module.exports = __webpack_public_path__ + "img/gift3-07-c1.e6e8f911.png";